/* Header option 1 (snippets/pc-hdr-1, 15 Oct 2026): scrolled state, the section in view (aria-current) and
   in-page anchor scrolling offset by this bar's height (the original header's script only handles its own links). */
(() => {
  const bar = document.querySelector('[data-ph1-bar]');
  if (!bar) return;
  const links = [...bar.querySelectorAll('a[data-ph1-link]')];
  let frame = 0;
  const desktop = matchMedia('(min-width: 1101px)');
  const sync = () => {
    frame = 0;
    if (!desktop.matches) return;
    const h = bar.offsetHeight;
    let current;
    for (const a of links) {
      const a0 = a.hash && document.getElementById(a.hash.slice(1));
      const t = a0 && (a0.closest('.ln-chapter') || a0); /* the chapter's top, as for clicks */
      if (t && t.getBoundingClientRect().top <= h + 100) current = a;
    }
    links.forEach(a => { if (a === current) { if (a.getAttribute('aria-current') !== 'true') a.setAttribute('aria-current', 'true'); } else if (a.hasAttribute('aria-current')) a.removeAttribute('aria-current'); });
  };
  const schedule = () => { if (desktop.matches && !frame) frame = requestAnimationFrame(sync); };
  const resize = new ResizeObserver(schedule);
  function activate() {
    cancelAnimationFrame(frame); frame = 0; resize.disconnect();
    removeEventListener('scroll', schedule); removeEventListener('resize', schedule);
    if (desktop.matches) {
      addEventListener('scroll', schedule, {passive:true}); addEventListener('resize', schedule, {passive:true});
      resize.observe(bar); schedule();
    }
  }
  desktop.addEventListener('change', activate);
  document.addEventListener('shopify:section:unload', e => {
    if (!e.target.contains(bar)) return;
    desktop.removeEventListener('change', activate); resize.disconnect(); cancelAnimationFrame(frame);
    removeEventListener('scroll', schedule); removeEventListener('resize', schedule);
  });
  bar.addEventListener('click', e => {
    const a = e.target.closest('a[data-ph1-link]');
    if (!a) return;
    const anchor = a.hash && document.getElementById(a.hash.slice(1));
    if (!anchor || a.pathname !== location.pathname) return;
    /* land on the chapter's own heading: #pricing sits on the plans block, below "Start with one account" */
    const target = anchor.closest('.ln-chapter') || anchor;
    e.preventDefault();
    const top = target.getBoundingClientRect().top + scrollY - bar.offsetHeight - 18;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    scrollTo({ top, behavior: reduced || Math.abs(top - scrollY) > innerHeight * 1.5 ? 'auto' : 'smooth' });
    const f = target.matches('h1,h2,h3') ? target : target.querySelector('h1,h2,h3') || target;
    if (!f.hasAttribute('tabindex')) { f.setAttribute('tabindex', '-1'); f.addEventListener('blur', () => f.removeAttribute('tabindex'), { once: true }); }
    f.focus({ preventScroll: true });
  });
  activate();
})();
